export function useScroll() {
  function scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  function scrollToElementTop(elementID: string) {
    const el = document.getElementById(elementID);
    if (el) {
      const y = el.getBoundingClientRect().top + window.scrollY - 100
      window.scrollTo({ top: y, behavior: 'smooth' })
    }
  }

  return {
    scrollToTop,
    scrollToElementTop
  }
}
